import {
  Bars3Icon,
  BuildingLibraryIcon,
  CameraIcon,
  ChartBarIcon,
  CodeBracketIcon,
  LightBulbIcon,
  RocketLaunchIcon,
  ShieldCheckIcon,
} from "@heroicons/react/24/outline";

const Services = () => {
  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container">
        <div className="max-w-2xl mx-auto text-center">
          <span className="text-sm text-primary uppercase font-semibold tracking-wider text-default-950">
            What We Offer
          </span>
          <h2 className="text-3xl md:text-4xl/tight font-semibold text-black mt-4">
            Asureis is more than just a CRM
          </h2>
          <p className="text-base font-medium mt-4 text-muted">
            It’s a complete solution designed to help ACA health insurance
            agents succeed. Our platform provides multiple tools such as:
          </p>
        </div>
        <div className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-x-3 gap-y-6 md:gap-y-12 lg:gap-y-24 md:pt-20 pt-12">
          <div className="text-center">
            <div className="flex items-center justify-center">
              <div className="items-center justify-center flex bg-primary/10 rounded-[49%_80%_40%_90%_/_50%_30%_70%_80%] h-20 w-20 border">
                <Bars3Icon className="h-10 w-10 text-primary" />
              </div>
            </div>
            <h1 className="text-xl font-semibold pt-4">Lead Management</h1>
            <p className="text-base text-gray-600 mt-2">
              Track and organize leads effortlessly to maximize conversions.
            </p>
          </div>
          <div className="text-center">
            <div className="flex items-center justify-center">
              <div className="items-center justify-center flex bg-primary/10 rounded-[49%_80%_40%_90%_/_50%_30%_70%_80%] h-20 w-20 border">
                <LightBulbIcon className="h-10 w-10 text-primary" />
              </div>
            </div>
            <h1 className="text-xl font-semibold pt-4">Automated Workflows</h1>
            <p className="text-base text-gray-600 mt-2">
              Reduce manual tasks and streamline your sales process.
            </p>
          </div>
          <div className="text-center">
            <div className="flex items-center justify-center">
              <div className="items-center justify-center flex bg-primary/10 rounded-[49%_80%_40%_90%_/_50%_30%_70%_80%] h-20 w-20 border">
                <ChartBarIcon className="h-10 w-10 text-primary" />
              </div>
            </div>
            <h1 className="text-xl font-semibold pt-4">Policy Tracking</h1>
            <p className="text-base text-gray-600 mt-2">
              Stay on top of enrollments, renewals, and client follow-ups.
            </p>
          </div>
          <div className="text-center">
            <div className="flex items-center justify-center">
              <div className="items-center justify-center flex bg-primary/10 rounded-[49%_80%_40%_90%_/_50%_30%_70%_80%] h-20 w-20 border">
                <CodeBracketIcon className="h-10 w-10 text-primary" />
              </div>
            </div>
            <h1 className="text-xl font-semibold pt-4">
              Commission Tracking & Reconciliation
            </h1>
            <p className="text-base text-gray-600 mt-2">
              Easily monitor commissions and generate reports on unpaid policies
              to ensure accurate reconciliation with carriers.
            </p>
          </div>
          <div className="text-center">
            <div className="flex items-center justify-center">
              <div className="items-center justify-center flex bg-primary/10 rounded-[49%_80%_40%_90%_/_50%_30%_70%_80%] h-20 w-20 border">
                <ShieldCheckIcon className="h-10 w-10 text-primary" />
              </div>
            </div>
            <h1 className="text-xl font-semibold pt-4">Compliance Tools</h1>
            <p className="text-base text-gray-600 mt-2">
              Ensure every step of your process meets industry regulations.
            </p>
          </div>
          <div className="text-center">
            <div className="flex items-center justify-center">
              <div className="items-center justify-center flex bg-primary/10 rounded-[49%_80%_40%_90%_/_50%_30%_70%_80%] h-20 w-20 border">
                <RocketLaunchIcon className="h-10 w-10 text-primary" />
              </div>
            </div>
            <h1 className="text-xl font-semibold pt-4">
              Seamless Integrations
            </h1>
            <p className="text-base text-gray-600 mt-2">
              Connect with hundreds of apps through Zapier, allowing automated
              data syncing and improved efficiency.
            </p>
          </div>
          <div className="text-center">
            <div className="flex items-center justify-center">
              <div className="items-center justify-center flex bg-primary/10 rounded-[49%_80%_40%_90%_/_50%_30%_70%_80%] h-20 w-20 border">
                <BuildingLibraryIcon className="h-10 w-10 text-primary" />
              </div>
            </div>
            <h1 className="text-xl font-semibold pt-4">Performance Insights</h1>
            <p className="text-base text-gray-600 mt-2">
              Real-time analytics to optimize your sales strategy.
            </p>
          </div>
          <div className="text-center">
            <div className="flex items-center justify-center">
              <div className="items-center justify-center flex bg-primary/10 rounded-[49%_80%_40%_90%_/_50%_30%_70%_80%] h-20 w-20 border">
                <CameraIcon className="h-10 w-10 text-primary" />
              </div>
            </div>
            <h1 className="text-xl font-semibold pt-4">Imagen Extra</h1>
            <p className="text-base text-gray-600 mt-2">
              Este es un campo restante del template
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
